/* ============================================================
   MIMOSA ROYALE — CONVERSION PSYCHOLOGY ENGINE
   Social proof · Exit intent · Urgency · Trust signals
   ============================================================ */

(function () {
  'use strict';

  /* ── Helpers ──────────────────────────────────────────── */
  const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
  const delay = ms => new Promise(r => setTimeout(r, ms));
  const once = key => {
    if (sessionStorage.getItem(key)) return false;
    sessionStorage.setItem(key, '1');
    return true;
  };

  /* ============================================================
     1. SOCIAL PROOF TOAST NOTIFICATIONS
     "🛒 Jessica from Miami just ordered Berry Mimosa"
  ============================================================ */
  const TOAST_DATA = [
    { name: 'Jessica M.', city: 'Miami, FL', product: 'Berry Mimosa', emoji: '🍓', ago: '2 min ago' },
    { name: 'Taylor R.', city: 'Nashville, TN', product: 'Orange Mimosa', emoji: '🍊', ago: 'Just now' },
    { name: 'Brianna K.', city: 'Atlanta, GA', product: 'Mango Mimosa', emoji: '🥭', ago: '5 min ago' },
    { name: 'Ashley D.', city: 'Los Angeles, CA', product: 'Watermelon Mimosa', emoji: '🍉', ago: '3 min ago' },
    { name: 'Camille R.', city: 'New York, NY', product: 'Variety 6-Pack Gift Set', emoji: '🎁', ago: 'Just now' },
    { name: 'Monique S.', city: 'Chicago, IL', product: 'Berry Mimosa 12-Pack', emoji: '🍓', ago: '7 min ago' },
    { name: 'Kylie M.', city: 'Scottsdale, AZ', product: 'Splash of Summer Gift Set', emoji: '☀️', ago: '1 min ago' },
    { name: 'Madison A.', city: 'San Diego, CA', product: 'Mango Mimosa', emoji: '🥭', ago: '4 min ago' },
    { name: 'Sophia C.', city: 'Dallas, TX', product: 'Pineapple Mimosa', emoji: '🍍', ago: 'Just now' },
    { name: 'Rachel T.', city: 'Seattle, WA', product: 'Orange Mimosa 24-Pack', emoji: '🍊', ago: '6 min ago' },
    { name: 'Lauren P.', city: 'Austin, TX', product: 'Very Berry Gift Set', emoji: '🎀', ago: '2 min ago' },
    { name: 'Emma S.', city: 'Charlotte, NC', product: 'Apple Mimosa', emoji: '🍏', ago: '8 min ago' },
    { name: 'Priya K.', city: 'Houston, TX', product: 'Mango Mimosa 12-Pack', emoji: '🥭', ago: '3 min ago' },
    { name: 'Danielle W.', city: 'Denver, CO', product: 'Berry Mimosa', emoji: '🍓', ago: 'Just now' },
    { name: 'Nicole B.', city: 'Portland, OR', product: 'Watermelon Mimosa', emoji: '🍉', ago: '11 min ago' },
    { name: 'Kayla M.', city: 'Honolulu, HI', product: 'Pineapple Mimosa 4-Pack', emoji: '🍍', ago: '5 min ago' },
    { name: 'Morgan K.', city: 'Boston, MA', product: 'Splash of Summer Gift Set', emoji: '🎁', ago: '1 min ago' },
    { name: 'Valeria M.', city: 'Miami, FL', product: 'Orange Mimosa', emoji: '🍊', ago: 'Just now' },
    { name: 'Sandra T.', city: 'Philadelphia, PA', product: 'Variety 6-Pack Gift Set', emoji: '🎁', ago: '9 min ago' },
    { name: 'Jasmine H.', city: 'New Orleans, LA', product: 'Berry Mimosa 12-Pack', emoji: '🍓', ago: '4 min ago' },
  ];

  let toastIndex = rand(0, TOAST_DATA.length - 1);
  let toastTimeout;

  function createToastContainer() {
    if (document.getElementById('mr-toast-container')) return;
    const container = document.createElement('div');
    container.id = 'mr-toast-container';
    container.innerHTML = '';
    document.body.appendChild(container);
  }

  function showToast() {
    const data = TOAST_DATA[toastIndex % TOAST_DATA.length];
    toastIndex++;

    const toast = document.createElement('div');
    toast.className = 'mr-toast';
    toast.innerHTML = `
      <div class="mr-toast-icon">${data.emoji}</div>
      <div class="mr-toast-body">
        <div class="mr-toast-title"><strong>${data.name}</strong> from ${data.city}</div>
        <div class="mr-toast-product">just ordered <strong>${data.product}</strong></div>
        <div class="mr-toast-time">${data.ago}</div>
      </div>
      <button class="mr-toast-close" aria-label="Dismiss">✕</button>
    `;

    const container = document.getElementById('mr-toast-container');
    container.appendChild(toast);

    toast.querySelector('.mr-toast-close').addEventListener('click', () => dismissToast(toast));

    // Animate in
    requestAnimationFrame(() => {
      requestAnimationFrame(() => toast.classList.add('mr-toast--visible'));
    });

    // Auto-dismiss after 5s
    const autoDismiss = setTimeout(() => dismissToast(toast), 5000);
    toast._autoDismiss = autoDismiss;

    // Next toast
    const nextDelay = rand(28000, 42000);
    toastTimeout = setTimeout(showToast, nextDelay);
  }

  function dismissToast(toast) {
    clearTimeout(toast._autoDismiss);
    toast.classList.remove('mr-toast--visible');
    toast.classList.add('mr-toast--hiding');
    setTimeout(() => toast.remove(), 400);
  }

  function initToasts() {
    createToastContainer();
    // First toast after 8-15 seconds
    setTimeout(showToast, rand(8000, 15000));
  }


  /* ============================================================
     2. EXIT INTENT POPUP
     Triggers on mouse leaving viewport top (desktop)
     or after 45s inactivity (mobile)
  ============================================================ */
  function createExitPopup() {
    if (document.getElementById('mr-exit-popup')) return;

    const overlay = document.createElement('div');
    overlay.id = 'mr-exit-popup';
    overlay.innerHTML = `
      <div class="mr-exit-modal">
        <button class="mr-exit-close" id="mrExitClose" aria-label="Close">✕</button>
        <div class="mr-exit-badge">✦ EXCLUSIVE OFFER ✦</div>
        <div class="mr-exit-crown">👑</div>
        <h2 class="mr-exit-title">Don't Leave<br/>Empty-Handed.</h2>
        <p class="mr-exit-subtitle">Join The Royale Circle and get <strong>10% off your first order</strong> — plus early access to new flavors.</p>
        <form class="mr-exit-form" id="mrExitForm">
          <input type="email" class="mr-exit-input" placeholder="Your email address…" required />
          <button type="submit" class="mr-exit-btn">Claim My 10% Off →</button>
        </form>
        <div class="mr-exit-success" id="mrExitSuccess" style="display:none;">
          <div class="mr-exit-success-icon">🥂</div>
          <div class="mr-exit-code">ROYALE10</div>
          <p>Your code is ready! Use it at checkout.</p>
          <button class="mr-exit-btn" onclick="window.location.href='shop.html'">Shop Now →</button>
        </div>
        <div class="mr-exit-no-thanks">
          <button id="mrExitNoThanks">No thanks, I'll pay full price</button>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);

    // Close handlers
    document.getElementById('mrExitClose').addEventListener('click', closeExitPopup);
    document.getElementById('mrExitNoThanks').addEventListener('click', closeExitPopup);
    overlay.addEventListener('click', e => { if (e.target === overlay) closeExitPopup(); });

    // Form submit
    document.getElementById('mrExitForm').addEventListener('submit', e => {
      e.preventDefault();
      document.getElementById('mrExitForm').style.display = 'none';
      document.getElementById('mrExitSuccess').style.display = 'block';
    });

    // Show with animation
    requestAnimationFrame(() => {
      requestAnimationFrame(() => overlay.classList.add('mr-exit-popup--visible'));
    });
  }

  function closeExitPopup() {
    const popup = document.getElementById('mr-exit-popup');
    if (!popup) return;
    popup.classList.remove('mr-exit-popup--visible');
    setTimeout(() => popup.remove(), 400);
  }

  function initExitIntent() {
    // Desktop: mouse leaving viewport
    let triggered = false;
    document.addEventListener('mouseleave', e => {
      if (triggered || e.clientY > 10) return;
      if (!once('mr-exit-shown')) return;
      triggered = true;
      setTimeout(createExitPopup, 300);
    });

    // Mobile: after 45s of page time if user hasn't purchased
    if (window.innerWidth < 768) {
      setTimeout(() => {
        if (!once('mr-exit-shown-mobile')) return;
        createExitPopup();
      }, 45000);
    }
  }


  /* ============================================================
     3. LIVE ORDER COUNTER
     "🔥 142 orders placed in the last 24 hours"
  ============================================================ */
  function initOrderCounter() {
    const targets = document.querySelectorAll('.products-grid, .shop-grid');
    if (!targets.length) return;

    const baseCount = rand(128, 194);
    const strip = document.createElement('div');
    strip.className = 'mr-order-counter';
    strip.innerHTML = `
      <span class="mr-order-fire">🔥</span>
      <span><strong id="mrOrderCount">${baseCount}</strong> orders placed in the last 24 hours</span>
      <span class="mr-order-dot"></span>
      <span>Ships within 24 hrs</span>
    `;

    // Insert before the first products grid
    const firstGrid = targets[0];
    firstGrid.parentNode.insertBefore(strip, firstGrid);

    // Slowly increment the count every 45-90 seconds
    setInterval(() => {
      const el = document.getElementById('mrOrderCount');
      if (!el) return;
      const current = parseInt(el.textContent);
      const increment = rand(1, 3);
      el.textContent = current + increment;
      // Brief flash
      el.style.color = '#12B76A';
      setTimeout(() => { el.style.color = ''; }, 800);
    }, rand(45000, 90000));
  }


  /* ============================================================
     4. FLOATING DEAL BANNER (Countdown to midnight)
     "Today only: Free shipping on ALL orders"
  ============================================================ */
  function initDealBanner() {
    return; // DISABLED: "Free shipping on ALL orders" contradicts the real $75+ free-ship threshold (was false advertising)
    // Only show once per session, after 3s
    if (!once('mr-deal-shown')) return;

    setTimeout(() => {
      const banner = document.createElement('div');
      banner.id = 'mr-deal-banner';
      banner.innerHTML = `
        <span class="mr-deal-text">⚡ Today Only: <strong>Free Shipping</strong> on All Orders — Ends in <span id="mrDealTimer">--:--:--</span></span>
        <a href="shop.html" class="mr-deal-cta">Shop Now</a>
        <button class="mr-deal-close" id="mrDealClose">✕</button>
      `;
      document.body.appendChild(banner);

      // Animate in
      requestAnimationFrame(() => {
        requestAnimationFrame(() => banner.classList.add('mr-deal-banner--visible'));
      });

      document.getElementById('mrDealClose').addEventListener('click', () => {
        banner.classList.remove('mr-deal-banner--visible');
        setTimeout(() => banner.remove(), 400);
      });

      // Countdown to midnight
      function updateTimer() {
        const now = new Date();
        const midnight = new Date();
        midnight.setHours(24, 0, 0, 0);
        const diff = midnight - now;
        const h = String(Math.floor(diff / 3600000)).padStart(2, '0');
        const m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
        const s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
        const el = document.getElementById('mrDealTimer');
        if (el) el.textContent = `${h}:${m}:${s}`;
      }
      updateTimer();
      setInterval(updateTimer, 1000);

      // Auto-hide after 20 seconds
      setTimeout(() => {
        if (banner.parentNode) {
          banner.classList.remove('mr-deal-banner--visible');
          setTimeout(() => banner.remove(), 400);
        }
      }, 20000);
    }, 3000);
  }


  /* ============================================================
     5. SMART CART BADGE UPDATER
     Updates cart count badge across the page
  ============================================================ */
  window.MR_Cart = {
    count: 0,
    add(qty = 1) {
      this.count += qty;
      document.querySelectorAll('.badge, #cartCount').forEach(el => {
        el.textContent = this.count;
        el.style.transform = 'scale(1.4)';
        setTimeout(() => { el.style.transform = ''; }, 300);
      });
    }
  };


  /* ============================================================
     6. FREE SHIPPING PROGRESS NUDGE (on product pages)
     Shows below the ATC button when user interacts
  ============================================================ */
  function initShippingNudge() {
    return; // DISABLED: redundant with the real cart-based free-ship bar in product.liquid (this one hardcoded a fake $14.99 cart, always showing "$60.01")
    const atcBtn = document.querySelector('.pdp-atc-btn, .product-add-btn');
    if (!atcBtn) return;

    const target = 75;
    let cartTotal = 14.99; // assume one 4-pack selected

    const nudge = document.createElement('div');
    nudge.className = 'mr-shipping-nudge';
    nudge.innerHTML = `
      <div class="mr-shipping-nudge-label">
        <span>🚚</span>
        <span>Add <strong id="mrShipRemain">$${(target - cartTotal).toFixed(2)}</strong> more for <strong>FREE shipping!</strong></span>
      </div>
      <div class="mr-shipping-nudge-track">
        <div class="mr-shipping-nudge-fill" id="mrShipFill" style="width:${(cartTotal/target*100).toFixed(0)}%"></div>
      </div>
    `;

    // Insert after the ATC row
    const atcRow = document.getElementById('atcRow');
    if (atcRow) {
      atcRow.parentNode.insertBefore(nudge, atcRow.nextSibling);
    }
  }


  /* ============================================================
     7. PRODUCT CARD QUICK-ADD FEEDBACK
     Brief success animation when "Quick Buy" clicked
  ============================================================ */
  function initQuickBuyFeedback() {
    document.querySelectorAll('[data-quick-buy]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        const flavor = this.dataset.quickBuy;
        // Brief ripple + text flash before navigating
        this.textContent = '✓ Added!';
        this.style.background = '#12B76A';
        setTimeout(() => {
          window.location.href = `product.html?flavor=${flavor}`;
        }, 600);
      });
    });
  }


  /* ============================================================
     8. STICKY "BACK TO TOP" + QUICK SHOP FLOATING BUTTON
  ============================================================ */
  function initFloatingShopBtn() {
    // Only on homepage and shop page, not product page
    if (document.getElementById('purchaseZone')) return;

    const fab = document.createElement('a');
    fab.href = 'shop.html';
    fab.className = 'mr-fab';
    fab.innerHTML = `
      <span class="mr-fab-icon">🛒</span>
      <span class="mr-fab-label">Shop Now</span>
    `;
    document.body.appendChild(fab);

    // Show after scrolling 600px
    window.addEventListener('scroll', () => {
      fab.classList.toggle('mr-fab--visible', window.scrollY > 600);
    }, { passive: true });
  }


  /* ============================================================
     9. "AS SEEN ON" TRUST STRIP — inject if not present
  ============================================================ */
  // Already handled in HTML sections


  /* ============================================================
     10. PRODUCT PAGE — BUNDLE UPSELL NUDGE
     "Customers who buy 3+ packs save up to $30"
  ============================================================ */
  function initBundleNudge() {
    // DISABLED 2026-07-01 — the "save $14" claim was mathematically false (24-Pack $119.75 vs
    // 6× 4-packs $119.94 = a $0.19 difference). The AOV tier ladder in product.liquid now carries
    // the honest value messaging (free shipping at $75+ / flutes GWP). Do not re-enable without real math.
    return;
  }


  /* ============================================================
     INIT — Run after DOM ready
  ============================================================ */
  function init() {
    // initToasts() DISABLED — fabricated "X just ordered" purchase popups (hardcoded fake names/cities/times) = FTC fake-activity risk.
    void initToasts;
    // Exit-intent email popup disabled — email capture is now the single 5s modal in theme.liquid.
    void initExitIntent;
    // initOrderCounter() DISABLED — fabricated "orders placed in the last 24 hours" counter with random base + increments = FTC fake-activity risk.
    void initOrderCounter;
    initDealBanner();
    // initFloatingShopBtn() DISABLED — floating "Shop Now" FAB collided with the Smile.io rewards launcher (bottom-right) + linked to a dead static shop.html path.
    void initFloatingShopBtn;
    initQuickBuyFeedback();

    // Product-page specific
    if (document.getElementById('purchaseZone')) {
      initShippingNudge();
      initBundleNudge();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
